import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { LayoutContext } from 'contexts';
import { capitalize } from 'utils';
import { Page } from 'components';
import NeedContext from '../NeedContext';
import Attachments from '../Attachments';
import { StyledMainGrid } from '../StyledComponents';
import UploadFile from './UploadFile';

const ManageFiles: React.FC = () => {
  const { needId } = useParams<Record<string, string>>();
  const { setAppTitle } = React.useContext(LayoutContext);
  const { need, files, isAuthorizedToEdit } = React.useContext(NeedContext);
  const history = useHistory();

  const title = React.useMemo(() => {
    if (!need) return '';
    return `${capitalize(need.type)} - Manage Photos/Files`;
  }, [need]);

  React.useEffect(() => {
    setAppTitle(title);
  }, [title]);

  if (!isAuthorizedToEdit) {
    history.replace(`/needs/${needId}/view`);
    return null;
  }

  return (
    <Page type="filled" title={title} showBackButton>
      <StyledMainGrid $minWidth="400px">
        <UploadFile />
        <Attachments canMove canDelete />
      </StyledMainGrid>
    </Page>
  );
};

export default ManageFiles;
